import { IRow, Row } from "@/components/commons/Generics/GenericTable/GenericTableRow";


/** Noeud de base */
class BaseNode extends Row {
	private _invariant: string;
	private _objectType: string;
	private _location: string;
	private _depreciated: boolean;

	public constructor(id: string, name: string, dataOrInvariant: string, objectType?: string, location?: string, depreciated?: boolean) 
	{
		/** @todo @MGillier A revoir ! */
		// if (typeof dataOrInvariant === 'object') 
		// {
		// 	super(id, name, dataOrInvariant);
		// 	Object.assign(this, dataOrInvariant);
		// } 
		// else 
		// {
			super(id, name, null);
			this._invariant = dataOrInvariant;
			this._objectType = objectType;
			this._location = location;
			this._depreciated = depreciated;
		// }
	}

	/** Invariant */
	public get Invariant(): string {
		return this._invariant;
	}

	public set Invariant(value: string) {
		this._invariant = value;
	}

	/** Indique le type d'objet */
	public get ObjectType(): string {
		return this._objectType;
	}

	public set ObjectType(value: string) {
		this._objectType = value;
	}

	/** Chemin dans l'arborescence */
	public get Location(): string {
		return this._location;
	}

	public set Location(value: string) {
		this._location = value;
	}

	/** Noeud déprécié ou non */
	public get Depreciated(): boolean {
		return this._depreciated;
	}

	public set Depreciated(value: boolean) {
		this._depreciated = value;
	}
}

export default BaseNode;